import { cn } from "../lib/utils";

const STATUS_CONFIG = {
  reception: {
    label: "Réception",
    className: "bg-slate-500/20 text-slate-400 border-slate-500/30",
  },
  diagnostic: {
    label: "Diagnostic",
    className: "bg-purple-500/20 text-purple-400 border-purple-500/30",
  },
  diagnostic_advanced: {
    label: "Diagnostic approfondi",
    className: "bg-violet-500/20 text-violet-400 border-violet-500/30",
  },
  quote_pending: {
    label: "Devis en attente",
    className: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  },
  quote_accepted: {
    label: "Devis accepté",
    className: "bg-emerald-500/20 text-emerald-400 border-emerald-500/30",
  },
  quote_rejected: {
    label: "Devis refusé",
    className: "bg-red-500/20 text-red-400 border-red-500/30",
  },
  pending_parts: {
    label: "En attente de pièces",
    className: "bg-orange-500/20 text-orange-400 border-orange-500/30",
  },
  in_repair: {
    label: "En réparation",
    className: "bg-blue-500/20 text-blue-400 border-blue-500/30",
  },
  testing: {
    label: "Test",
    className: "bg-pink-500/20 text-pink-400 border-pink-500/30",
  },
  ready: {
    label: "Prêt",
    className: "bg-teal-500/20 text-teal-400 border-teal-500/30",
  },
  delivered: {
    label: "Livré",
    className: "bg-green-600/20 text-green-500 border-green-500/30",
  },
  cancelled: {
    label: "Annulé",
    className: "bg-gray-500/20 text-gray-400 border-gray-500/30",
  },
};

export const StatusBadge = ({ status, className }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.reception;
  
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "px-3 py-1 rounded-full text-xs font-medium border inline-flex items-center",
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};

export const getStatusLabel = (status) => {
  return STATUS_CONFIG[status]?.label || status;
};

export const REPAIR_STATUSES = Object.keys(STATUS_CONFIG);
